import { Component, Input } from '@angular/core';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-biens-comparables-vendus-read-mode',
  templateUrl: './biens-comparables-vendus-read-mode.component.html',
  styleUrls: ['./biens-comparables-vendus-read-mode.component.scss'],
})
export class BiensComparablesVendusReadModeComponent {
  @Input() references!: Report.References;
  @Input() reportType!: string;
}
